export const Data = [
   {
    img:'https://a0.muscache.com/im/pictures/2f13349d-879d-43c6-83e3-8e5679291d53.jpg?im_w=320' ,
    title:'Outdoor getaways' ,
    id : 1 
   } ,
   {
    img:'https://a0.muscache.com/im/pictures/36f53e61-db8d-403c-9122-5b761c0e4264.jpg?im_w=320' ,
    title:'Unique stays' ,
    id : 2 
   } ,
   {
    img:'https://a0.muscache.com/im/pictures/7d82ca14-56e5-4465-8218-dcfa7d69b6ac.jpg?im_w=320' ,
    title:'Entire homes' ,
    id : 3 
   } ,
   {
    img:'https://i.ibb.co/NNrMPcq/1.jpg' ,
    title:'Featured collection:Wanderlust' ,
    id : 1 
   } ,
   {
    img:'https://i.ibb.co/qBY6b7t/2.jpg' ,
    title:'0nline Experiences' ,
    id : 2 
   } ,
   {
    img:'https://i.ibb.co/vqfJ8MT/3.jpg' ,
    title:'Experiences' ,
    id : 3 
   }
]

export const SearchCard = [
  {img:'https://a0.muscache.com/im/pictures/b11ec978-551a-4386-8656-3bf8fcf75e7a.jpg?im_w=960',location:'Kolkata',title:'Maple -The Residence',price:'18'},
  {img:'https://a0.muscache.com/im/pictures/e3fc8e56-cdf0-47dd-99dc-5610467c581d.jpg?im_w=960',location:'Dahaka',title:'White Palace Hotel',price:'85'},
  {img:'https://a0.muscache.com/im/pictures/1632a1b7-bd74-49cf-be54-e8dedd7d5a55.jpg?im_w=960',location:'Chandpur',title:'Farm stay',price:'89'},
  {img:'https://a0.muscache.com/im/pictures/453efc29-d14e-4edf-b1ba-5dd82a63e3f7.jpg?im_w=960',location:'London',title:'Entire condominium',price:'88'},
  {img:'https://a0.muscache.com/im/pictures/cbe98d6c-a5e7-4cd7-8390-3ca91c2b3cd7.jpg?im_w=960',location:'Arab emarat',title:'Entire loft',price:'69'},
  {img:'https://a0.muscache.com/im/pictures/cbe98d6c-a5e7-4cd7-8390-3ca91c2b3cd7.jpg?im_w=960',location:'puran Dhaka',title:'Hotel Miskisan',price:'36'},
  {img:'https://a0.muscache.com/im/pictures/6101647f-0585-46b4-b028-ae6cbf35e368.jpg?im_w=960',location:'Mini bangladesh',title:'Seaview Apartment',price:'86'},
  {img:'https://a0.muscache.com/im/pictures/cbe98d6c-a5e7-4cd7-8390-3ca91c2b3cd7.jpg?im_w=960',location:'Chittogong',title:'Entire condominium',price:'0.32'},
  {img:'https://a0.muscache.com/im/pictures/b11ec978-551a-4386-8656-3bf8fcf75e7a.jpg?im_w=960',location:'Kolkata',title:'Maple -The Residence',price:'755'},
  {img:'https://a0.muscache.com/im/pictures/e3fc8e56-cdf0-47dd-99dc-5610467c581d.jpg?im_w=960',location:'Dahaka',title:'White Palace Hotel',price:'86'},
]